import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { client } from '../../utils/trpc';
import Error from '../common/Error';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
import AwardListitem from './AwardListitem';
type Props = {
  closeHandler: () => void;
  postId: string;
};
const AwardsList = t0 => {
  const $ = _c(13);
  const {
    closeHandler,
    postId
  } = t0;
  let t1;
  if ($[0] !== postId) {
    t1 = {
      queryKey: ["awardsList", postId],
      queryFn: () => unwrapFromResult(client.awards.postAwards.query({
        postId
      }))
    };
    $[0] = postId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isLoading,
    data,
    error
  } = useQuery(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2>Awards</h2>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== closeHandler) {
    t3 = <ModalHeader closeHandler={closeHandler}>{t2}</ModalHeader>;
    $[3] = closeHandler;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data?.data || $[6] !== error || $[7] !== isLoading) {
    t4 = !isLoading && !error && <ModalContent><div className="max-h-[400px] w-full overflow-y-auto">{data?.data.map(_temp)}{data?.data.length === 0 && <p className="w-full py-4 text-center text-secondary">This post hasn't received any awards yet.</p>}</div><Error loading={isLoading} error={Boolean(error)} /></ModalContent>;
    $[5] = data?.data;
    $[6] = error;
    $[7] = isLoading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== closeHandler || $[10] !== t3 || $[11] !== t4) {
    t5 = <Modal closeHandler={closeHandler}>{t3}{t4}</Modal>;
    $[9] = closeHandler;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default AwardsList;
function _temp(postAward) {
  return <AwardListitem key={postAward.id} {...postAward} />;
}